export class PublisherGroupModel {
    constructor(public id: number, public name: string) {
    }
}


// WEBPACK FOOTER //
// ./src/app/core/services/publisher-group.model.ts